import rootReducer from "./rootReducer";
const configureStore = require("@reduxjs/toolkit").configureStore;

const store = configureStore({ reducer: rootReducer });

export default store;
